if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      // Just call the parent behavior
      super.hide();
    }

    show(opener) {
      // Make sure `opener` (the button that opened this modal) is recorded
      // so that `this.openedBy` is available in showActiveMedia()
      this.openedBy = opener || null;
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      // If for some reason show() was called without an opener, bail:
      if (!this.openedBy) return;

      // Grab the “data-media-id” that triggered this modal
      const mediaId = this.openedBy.getAttribute('data-media-id');
      if (!mediaId) return;

      // 1) Remove “active” from all siblings (but only if they actually have data-media-id)
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((el) => {
        el.classList.remove('active');
      });

      // 2) Find the matching media element inside the modal
      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      // 3) If there’s a <template> inside this media, grab its content
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent  = activeMediaTemplate ? activeMediaTemplate.content : null;

      // 4) Mark it “active” and scroll it into view
      activeMedia.classList.add('active');
      // If you want smooth scrolling, you could do:
      // activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      activeMedia.scrollIntoView();

      // 5) Center the activeMedia horizontally within its “[role=document]” container:
      const container = this.querySelector('[role="document"]');
      if (container) {
        // Use offsetWidth instead of .width
        const mediaWidth     = activeMedia.offsetWidth  || 0;
        const containerWidth = container.clientWidth || 0;
        container.scrollLeft = (mediaWidth - containerWidth) / 2;
      }

      // 6) If the element is a <deferred-media> and its template has a “.js-youtube” child,
      //    ask it to load its content now:
      if (
        activeMedia.nodeName === 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube') &&
        typeof activeMedia.loadContent === 'function'
      ) {
        activeMedia.loadContent();
      }
    }
  });
}